import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {Typography} from 'antd';
import NewsList from '../components/News/NewsList';

const { Text } = Typography;

const SearchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';

  return (
    <div style={{ padding: '5px' }}>
      {query && (
        <div style={{ maxWidth: '1000px', margin: '0 auto 8px', padding: '0 24px' }}>
          <Text type="secondary">
            Search results for "{query}"
          </Text>
        </div>
      )}
      {query && <NewsList searchQuery={query} />}
    </div>
  );
};

export default SearchPage;
